@if (loading) {
  <div class="row d-flex justify-content-around">
    <div>
      <app-spinner></app-spinner>
    </div>
  </div>
}
<div #container id="my_dataviz-{{chartId}}" (click)="chartClick($event)" [ngClass]="{'clickable' : clickable}"></div>
<!-- <div class="info card" [style.top.px]="popupTop" [style.left.px]="popupLeft" style="z-index: 1000">
<p class="m-0">{{'PLANNING.PARK.TURBINE_SERIAL' |translate}}: <b>{{turbineHovered}}</b></p>
</div> -->